import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import { Menu, Tab } from 'semantic-ui-react'
import { useAuth } from '~/routes/components/AuthProvider'
import { CO2_LFL_SLUG, FAT_PROTEIN_SLUG, MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE } from '~/Constants'
import MilkFixedPriceDashboard from './Tabs/MilkFixedDashboard'
import CO2Dashboard from './Tabs/CO2Dashboard'
import FatProteinDashboard from './Tabs/FatProteinDashboard'
import StockExchangeDashboard from './Tabs/StockExchangeDashboard'

const Dashboard: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const { systemData: { modules } } = useAuth()

  const [activeTabIndex, setActiveTabIndex] = useState<string | number>(0)

  const hasMilkFixedModule = modules.find(module => module.slug === MILK_FIXED_SLUG)
  const hasFatProteinModule = modules.find(module => module.slug === FAT_PROTEIN_SLUG)
  const hasStockExchangeModule = modules.find(module => module.slug === MILK_STOCK_EXCHANGE)
  const hasCo2Module = modules.find(module => module.slug === CO2_LFL_SLUG)

  function renderDashboards() {
    const panes = [
      {
        menuItem: t('Milk Fixed Price'),
        render: () => <MilkFixedPriceDashboard />,
        display: hasMilkFixedModule,
        key: t('Milk Fixed Price')
      },
      {
        menuItem: t('Milk fixed price (F. & P.)'),
        render: () => <FatProteinDashboard />,
        display: hasFatProteinModule,
        key: t('Milk fixed price (F. & P.)')
      },
      {
        menuItem: t('Stock exchange'),
        render: () => <StockExchangeDashboard />,
        display: hasStockExchangeModule,
        key: t('Stock exchange')
      },
      {
        menuItem: <Menu.Item><div>CO<sub>2</sub> Klima Check</div></Menu.Item>,
        render: () => <CO2Dashboard />,
        display: hasCo2Module,
        key: 'Co2-klima-check'
      }
    ];

    return <Tab
      menu={{ secondary: true, pointing: true }}
      activeIndex={activeTabIndex}
      panes={panes.filter(pane => pane.display)}
      onTabChange={(_, data) => setActiveTabIndex(data.activeIndex)}
    />
  }

  return <Layout
    segmented
    title={''}
    removeHeader
  >
    {renderDashboards()}
  </Layout>
}
export default Dashboard

